export default __webpack_public_path__ + "static/media/RajeevSir.bdf2bf87.webp";